import { K9 } from "../k9_data";
import { JdPokerComponent } from "../../../../jd/module/table/component/jd_poker_component";
import { K9HoldSprite } from "./k9_hold_sprite";
import K9Sound from "./k9_sound";
import Utility from "../../../../../utility/utility";
import K9Help from "./k9_help";
import { PokerCommonColor } from "./poker_com_color";

const {ccclass, property} = cc._decorator;

//天8
@ccclass
export default class K9Tian8 extends cc.Component {
    @property([cc.SpriteFrame])
    tian8:cc.SpriteFrame[] = [];

    @property(cc.Sprite)
    tian8Sprite:cc.Sprite = null;

    @property(cc.Sprite)
    tian8SpriteCopy:cc.Sprite = null;

    @property([cc.Animation])
    animation:cc.Animation[] = [];

    @property([PokerCommonColor])
    pokers:PokerCommonColor[] = [];

    @property(K9HoldSprite)
    holdSprite:K9HoldSprite = null;

    @property(cc.Sprite)
    beishu:cc.Sprite = null;

    @property(cc.Node)
    pattern:cc.Node = null;

    protected animName:string = 'anim_K9_tian89';

    //播放动画
    playAllAnim(isPlay:boolean = true){
        let anim = this.animation[0];
        if (anim.node.active) {
            if (isPlay) {
                anim.play()
            }else{
                K9Help.setAnimToEnd(this.animName,anim);
            }
        }
    }

    //默认播放动画
    onShow(data:K9.SeatData,isPlay:boolean = true){
        if (!data) {
            return;
        }
        this.node.active = true;
        if (data.cards.length < 2) {
            return;
        }
        for (let i = 0; i < 2; i++) {
            this.pokers[i].code = data.cards[i];
            this.pokers[i].showCardOnly();
        }
        this.playAllAnim(isPlay);
        //2.3.5
        if (data.card_type == K9.CardType.K8) {
            this.tian8Sprite.spriteFrame = this.tian8[0];
            this.tian8SpriteCopy.spriteFrame = this.tian8[0];
            K9Sound.playT8T9();
        }else if (data.card_type == K9.CardType.K9) {
            this.tian8Sprite.spriteFrame = this.tian8[1];
            this.tian8SpriteCopy.spriteFrame = this.tian8[1];
            K9Sound.playT8T9();
        }
        //更新倍数
        if (data.win_rate == 2 || data.win_rate == 3 || data.win_rate == 5) {
            this.beishu.node.active = true;
            this.beishu.spriteFrame = this.holdSprite.getSpriteFrameByName('k8_' + data.win_rate);
        }else{
            this.beishu.node.active = false;
        }
    }

    onReset(){
        this.node.active = false;
    }

    //置灰牌型
    grayNode(isGray:boolean){
        Utility.setNodeGray(this.pattern,isGray);
    }

}
